import { abbrNum } from '@src/shared/includes/functions';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { Tooltip } from '@uhg-abyss/web/ui/Tooltip';
import React from 'react';

import { Styles } from './includes/styles';

/**
 * RedEntities
 *
 * Displays the total number of red entities, the number with no active action path, and the number with an active
 * action path.
 *
 * @param data
 * @returns {Element}
 * @constructor
 */
export function RedEntities({ data = {} }) {
  return (
    <ErrorHandler location="src/pages/private/Dashboards/RiskDashboard/components/Details/components/RedEntities/RedEntities.jsx">
      <Styles>
        <div className="wrap">
          <div className="total data-box">
            <Tooltip content={`${Number(data?.countTotal).toLocaleString('en-US')}`}>
              <ul className="list">
                <li className="item">
                  <small>Total Red</small>
                  <Heading offset={3}>{abbrNum(data?.countTotal)}</Heading>
                </li>
              </ul>
            </Tooltip>
          </div>
          <div className="active data-box">
            <ul className="list">
              <Tooltip content={`${Number(data?.activeTotal).toLocaleString('en-US')}`}>
                <li className="item">
                  <small>Active</small>
                  <Heading offset={3}>{abbrNum(data?.activeTotal)}</Heading>
                </li>
              </Tooltip>
              <Tooltip content={`${Number(data?.inActiveTotal).toLocaleString('en-US')}`}>
                <li className="item">
                  <small>Inactive</small>
                  <Heading offset={3}>{abbrNum(data?.inActiveTotal)}</Heading>
                </li>
              </Tooltip>
            </ul>
          </div>
          <div className="action data-box">
            <ul className="list">
              <Tooltip content={`${Number(data?.countNoActiveActionPath).toLocaleString('en-US')}`}>
                <li className="item">
                  <small>No Action Path</small>
                  <Heading offset={3}>{abbrNum(data?.countNoActiveActionPath)}</Heading>
                </li>
              </Tooltip>
              <Tooltip content={`${Number(data?.countActionPathActive).toLocaleString('en-US')}`}>
                <li className="item">
                  <small>In Action Path</small>
                  <Heading offset={3}>{abbrNum(data?.countActionPathActive)}</Heading>
                </li>
              </Tooltip>
            </ul>
          </div>
        </div>
      </Styles>
    </ErrorHandler>
  );
}
